import { render, staticRenderFns } from "./WorldWideAssets.vue?vue&type=template&id=38bcd9d2&scoped=true"
import script from "./WorldWideAssets.vue?vue&type=script&lang=js"
export * from "./WorldWideAssets.vue?vue&type=script&lang=js"
import style0 from "./WorldWideAssets.vue?vue&type=style&index=0&id=38bcd9d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bcd9d2",
  null
  
)

export default component.exports